<mat-card class="otp-card">
  <mat-card-header>
    <mat-card-title>Error</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <p>Client ID not found. Please check the URL for errors and try again.</p>
  </mat-card-content>
</mat-card>
